import defaultClient from '@src/api/clients/default';

export function fetchNotifications(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/notifications/',
    payload,
  });
}

export function fetchUnreadNotificationCount() {
  return defaultClient.request({
    url: 'dashboard/notifications/unread-count/',
  });
}

export function markNotificationRead(notificationId) {
  return defaultClient.request({
    url: `dashboard/notifications/${notificationId}/mark-read/`,
    method: 'POST',
  });
}

export function markAllNotificationsRead() {
  return defaultClient.request({
    url: 'dashboard/notifications/mark-all-read/',
    method: 'POST',
  });
}

export default {
  fetchNotifications,
  fetchUnreadNotificationCount,
  markNotificationRead,
  markAllNotificationsRead,
};
